import { Component, OnInit } from '@angular/core';
import {
  AbstractControl,
  FormBuilder,
  FormGroup,
  Validators,
  ValidationErrors,
  ValidatorFn,
} from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import {
  HttpErrorHandlerService,
  MessageType,
} from 'src/app/shared-resources/services/http-error-handling.service';
import { UserInfoService } from 'src/app/shared-resources/services/user-info.service';
import { setPassword } from '../interfaces/forgot-pass.interface';
import { ForgotPassService } from '../services/forgot-password';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.less'],
})
export class ResetPasswordComponent implements OnInit {
  public validateForm: FormGroup;
  public loading: boolean;
  public TOKEN: string;
  public userName: string;
  public accountActivated: boolean;
  public alreadyActivated: boolean;
  public activationError: boolean;
  public passwordVisible = false;

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private forgotpassService: ForgotPassService,
    private httpMessage: HttpErrorHandlerService,
    private translate: TranslateService,
    private userInfoService: UserInfoService,
    private activatedRoute: ActivatedRoute
  ) {}
  signin(): void {
    this.router.navigateByUrl('/login');
  }
  signup(): void {
    this.router.navigateByUrl('/signup');
  }
  submitForm(): void {
    for (const i in this.validateForm.controls) {
      if (i) {
        this.validateForm.controls[i].markAsDirty();
        this.validateForm.controls[i].updateValueAndValidity();
      }
    }
  }

  resetPassword(): void {
    this.loading = true;
    if (this.validateForm.valid && this.TOKEN !== null) {
      const setPasswordRequest: setPassword = {
        username: this.userName,
        newPassword: this.validateForm.controls['password'].value,
        token: this.TOKEN,
        pwdSetType: 'RESET'
      };
      this.forgotpassService.setPassword(setPasswordRequest).subscribe(
        () => {
          this.loading = false;
          this.httpMessage.showTopFloatMessage(
            this.translate.instant('app.resetpassword.success'),
            MessageType.SUCCESS,
            this.translate.instant('app.label.success')
          );
          this.router.navigateByUrl('/login');
        },
        (error: any) => {
          this.httpMessage.showTopFloatMessage(
            error.error,
            MessageType.ERROR,
            this.translate.instant('app.label.error')
          );
          this.loading = false;
          this.validateForm.reset();
        }
      );
    } else {
      this.loading = false;
    }
  }
  ngOnInit(): void {
    const queryParams = this.activatedRoute.snapshot.queryParams;
    this.TOKEN = queryParams['confirmation'];
    this.userName = queryParams['username'];

    if (this.userName != null && this.TOKEN !== null) {
      this.userInfoService.setUserName(atob(this.userName).split('/')[1]);
    } else {
      this.router.navigateByUrl('/login');
    }
    this.validateForm = this.fb.group(
      {
        password: [null, Validators.compose([Validators.required])],
        cpassword: [null, Validators.compose([Validators.required])],
      },
      {
        validators: this.passwordMatchValidator,
      }
    );
  }

  patternValidator(regex: RegExp, error: ValidationErrors): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      if (!control.value) {
        return null;
      }
      const valid = regex.test(control.value);
      return valid ? null : error;
    };
  }

  passwordMatchValidator(control: AbstractControl): void {
    const password: string = control.get('password')?.value;
    const confirmPassword: string = control.get('cpassword')?.value;
    if (password !== confirmPassword) {
      control.get('cpassword')?.setErrors({ NoPassswordMatch: true });
    }
  }
}
